<template>
    <ul class="attachment-list" v-if="attachmentList.length > 0">
        <li v-for="(att, index) in attachmentList" :key="index">
            <md-icon>
                {{ fileType === 'document' ? 'picture_as_pdf' : 'image' }}
            </md-icon>

            <md-tooltip md-direction="top">
                {{ att.file.name }}
            </md-tooltip>
        </li>
    </ul>
</template>

<script>
export default {
    name: 'BlockoutDaysAttachmentGroup',
    props: {
        attachmentList: {
            type: Array,
            default: () => [],
            required: true
        },
        fileType: {
            type: String,
            default: 'document'
        }
    }
};
</script>

<style lang="scss" scoped>
.attachment-list {
    list-style: none;
    padding: 0;
    margin: 0;

    display: flex;
    align-items: center;
    gap: 3px;
    flex-wrap: wrap;
}
</style>
